import { render, staticRenderFns } from "./classesChart.vue?vue&type=template&id=2671e306&"
import script from "./classesChart.vue?vue&type=script&lang=js&"
export * from "./classesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports